import { Flex, HStack } from '@chakra-ui/react';
import CanopyInput from '../../canopy-ui-components/components/CanopyInput/CanopyInput';
import CanopyTooltipIconButton from '../../canopy-ui-components/components/CanopyTooltipIconButton/CanopyTooltipIconButton';
import ActClose from '../../canopy-ui-components/components/Icons/ActClose';
import { useCurrentColors } from '../../canopy-ui-components/hooks/UseCurrentColors/UseCurrentColors';

const EditInfoRow = ({
    item,
    index,
    updateItem,
    deleteItem,
    globalProps,
}: any) => {
    const currentColors = useCurrentColors();
    return (
        <>
            <HStack
                width="100%"
                spacing="20px"
                justifyContent="end">
                <CanopyInput
                    height="30px"
                    fontSize="md"
                    backgroundColor={currentColors?.white}
                    _hover={{ backgroundColor: currentColors?.white }}
                    _focus={{ backgroundColor: currentColors?.white }}
                    placeholder="Key"
                    value={item.key}
                    onChange={(e) =>
                        updateItem('key', e.target.value, index)
                    }></CanopyInput>
                <CanopyInput
                    height="30px"
                    fontSize="md"
                    backgroundColor={currentColors?.white}
                    _hover={{ backgroundColor: currentColors?.white }}
                    _focus={{ backgroundColor: currentColors?.white }}
                    placeholder="Value"
                    value={item.value}
                    onChange={(e) =>
                        updateItem('value', e.target.value, index)
                    }></CanopyInput>
                <Flex
                    height="30px"
                    alignItems="center">
                    <CanopyTooltipIconButton
                        label={globalProps.t('delete')}
                        icon={<ActClose />}
                        arialLabel="delete-mappings"
                        clickHandler={() => deleteItem(index)}
                    />
                </Flex>
            </HStack>
        </>
    );
};

export default EditInfoRow;
